import { Settings } from "react-slick";

export const QuickPlayWebSettings: Settings = {
	arrows: true,
	dots: false,
	infinite: true,
	variableWidth: true,
	speed: 300,

	slidesToShow: 3,
	slidesToScroll: 3,
	touchThreshold: 100,

	responsive: [
		{
			breakpoint: 1669,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 2,
			},
		},
		{
			breakpoint: 1360,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
			},
		},
		{
			breakpoint: 1020,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
			},
		},
	],
};

export const MobileSettings: Settings = {
	arrows: false,
	dots: false,
	speed: 300,
	variableWidth: true,

	slidesToShow: 1,
	infinite: true,
};
